Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = '2.3.0';
//# sourceMappingURL=SearchkitVersion.js.map